module.exports = __webpack_public_path__ + "img/icon-home-tp-01.9e1a2986.jpg";